// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3iyd4","imageUploader":"EGiftCard_imageUploader__16ePi"};